import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { ConfirmationAction } from '../../../dialogs';
import BackBtn from './BackBtn';

const messages = defineMessages({
  BACK_TOOLTIP: {
    id: 'BACK_TOOLTIP',
    defaultMessage: 'Finish editing and return to the board',
  },
  CONFIRM_BACK_MSG: {
    id: 'CONFIRM_BACK_MSG',
    defaultMessage: 'Discard unsaved changes?',
  },
  CONFIRM_BACK_BODY: {
    id: 'CONFIRM_BACK_BODY',
    defaultMessage: 'You made changes to the board. Are you sure you want to discard changes and go back?',
  },
  DISCARD: {
    id: 'DISCARD',
    defaultMessage: 'Discard',
  },
});

function BackBtnConfirm({ onBack }) {
  return (
    <ConfirmationAction
      onConfirm={onBack}
      tooltipMsg={<FormattedMessage {...messages.BACK_TOOLTIP} />}
      confirmMsg={<FormattedMessage {...messages.CONFIRM_BACK_MSG} />}
      confirmBody={<FormattedMessage {...messages.CONFIRM_BACK_BODY} />}
      confirmActionMsg={<FormattedMessage {...messages.DISCARD} />}
    >
      <BackBtn onBack={onBack} />
    </ConfirmationAction>
  );
}

BackBtnConfirm.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default BackBtnConfirm;
